import { createSlice } from "@reduxjs/toolkit";

import { createCustomerSubscription } from "../actions"
import { downloadInvoice } from "./actions"

const initialState = {
  loadedFirstTime: false,
  loading: false,
  redirect: false,
  targetRedirect: "",
  user: {},
  card: {},
  invoice: {},
  subscription: {},
  downloadUrl:""
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState: initialState,
  reducers: {
    resetUrlInvoice: (state) => {state.downloadUrl = ""}
  },
  extraReducers: (builder) => {
    builder.addCase(createCustomerSubscription.fulfilled, (state, action) => {
      state.loadedFirstTime = true;
      state.user = action.payload.data.customer;
      state.card = action.payload.data.card;
      state.invoice = action.payload.data.invoice;
      state.subscription = action.payload.data.subscription;
    });

    builder.addCase(downloadInvoice.fulfilled, (state, action) => {
      state.loading = false;
      state.downloadUrl = action.payload.success ? action.payload.data.downloadUrl : "";
    });
    builder.addCase(downloadInvoice.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(downloadInvoice.rejected, (state, action) => {
      state.loading = false;
    });
  }
});

export const { resetUrlInvoice } = invoiceSlice.actions;
export default invoiceSlice.reducer;